import React from 'react';
import confirm from 'utils/confirm';
import noop from 'lodash/noop';
import urlParams from 'utils/urlParams';
import SelectField from 'components/pure/utils/form/SelectField';
import {departmentProfiles} from 'utils/const';
import {browserHistory} from 'react-router';

export default class DepartmentProfileSwitcher extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.onChangeProfile = this.onChangeProfile.bind(this);
  }

  getProfileIdProperty() {
    return `${this.props.type}Id`;
  }

  setProfileId(newId) {
    this.props.updateDepartment(this.props.department.set(this.getProfileIdProperty(), newId));
  }

  onChangeProfile(newId) {
    if (newId === undefined) {
      this.redirectToProfileCreatePage();
      return;
    }
    const {options, type, department} = this.props;
    const oldId = department[this.getProfileIdProperty()];
    const oldProfile = options.find(({id}) => id === oldId);
    const newProfile = options.find(({id}) => id === newId);
    const profileName = departmentProfiles[type].label.toLowerCase();
    if (this.props.showConfirmModal) {
      const title = `Change ${profileName} Profile?`;
      const message =
        `Are you sure you want to change the ${profileName} profile for
        "${department.name}"` +
        (oldProfile ? ` from "${oldProfile.name}"` : '') +
        ` to "${newProfile ? newProfile.name : 'None'}?"`;
      confirm(message, title).then(() => this.setProfileId(newId), noop);
    } else {
      this.setProfileId(newId);
    }
  }

  redirectToProfileCreatePage() {
    const {newProfileRoute} = this.props;
    if (newProfileRoute) {
      const url = `${newProfileRoute}/new`;
      browserHistory.push(url + urlParams({addToDepartment: true}));
    }
  }

  render() {
    const allowNull = departmentProfiles[this.props.type].allowNull;
    let options = this.props.options.map(({id, name}) => {
      return {label: name, value: id};
    });
    if (this.props.newProfileRoute) {
      options = options.concat({
        label: 'Create New Profile',
      });
    }
    if (allowNull) {
      options = options.unshift({
        label: 'None',
        value: null,
      });
    }
    return this.props.wasError ? (
      <div>Loading error.</div>
    ) : (
      <SelectField
        value={this.props.department[this.getProfileIdProperty()]}
        hideResetButton={true}
        tether={true}
        options={options}
        onChange={this.onChangeProfile}
      />
    );
  }
}
